import * as Yup from "yup";
import { isValidPhoneNumber } from 'react-phone-number-input';

const formValidationSchema = Yup.object().shape({
    firstName: Yup.string()
        .trim()
        .min(2, "First name must be at least 2 characters")
        .max(50, "First name must not exceed 50 characters")
        .matches(
            /^[a-zA-Z\s'-]+$/,
            "First name can only contain letters, spaces, hyphens, and apostrophes"
        )
        .required("First name is required"),

    lastName: Yup.string()
        .trim()
        .min(2, "Last name must be at least 2 characters")
        .max(50, "Last name must not exceed 50 characters")
        .matches(
            /^[a-zA-Z\s'-]+$/,
            "Last name can only contain letters, spaces, hyphens, and apostrophes"
        )
        .required("Last name is required"),

    email: Yup.string()
        .trim()
        .email("Invalid email format")
        .matches(
            /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
            "Please enter a valid email address"
        )
        .required("Email is required"),

    phone: Yup.string()
        .required("Phone number is required")
        .test(
            'is-valid-phone',
            'Valid phone number is required',
            (value) => !!value && isValidPhoneNumber(value)
        ),
    country: Yup.string()
        .trim()
        .required("Country is required")
        .min(2, "Country name must be at least 2 characters")
        .max(100, "Country name is too long")
        .matches(
            /^[a-zA-Z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s'&.-]+$/,
            "Please enter a valid country name"
        ),

});
export default formValidationSchema;

